"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
function getContentStatus(content) {
    try {
        const modelType = content.modelType;
        switch (modelType) {
            case 'offer':
                return content.offerDeleted || content.deleted ? entity_1.ContentStatus.DELETED : entity_1.ContentStatus.ACTIVE;
            case 'curriculumOffer':
                return content.curriculumOfferDeleted || content.deleted ? entity_1.ContentStatus.DELETED : entity_1.ContentStatus.ACTIVE;
            case 'activity':
                return content.status === 'deleted' ? entity_1.ContentStatus.DELETED : entity_1.ContentStatus.ACTIVE;
            default:
                throw new Error('Invalid type ' + modelType);
        }
    }
    catch (error) {
        throw new Error('Error in getContentStatus ' + error);
    }
}
exports.default = getContentStatus;
//# sourceMappingURL=getContentStatus.js.map